export default [
	{
		name: 'TeacherUsers',
		path: 'users',
		component: () => import('@/pages/teacher/components/user/Users'),
	},
];
